import { Popover } from 'antd';

const AllocationTargetError = ({ isTarget = false }) => {
	return (
		<Popover
      placement="leftBottom"
      title="Allocation Value Target Account Error"
      open={!!isTarget} // if antd v4: visible={!!isTarget}
      content="The value cannot be changed due to the account being a target account of an allocation."
    />
	);
};

export default AllocationTargetError;
